import { useCallback, useMemo } from 'react';

import { makeSpacesNoBreak } from 'utils/string';

import { useLocale } from '../useSitecoreContext';

/**
 * Format a weight in grams or kilograms according to the current locale.
 */
export function useWeightFormatter() {
	const { locale } = useLocale();

	// Available units: https://tc39.es/ecma402/#table-sanctioned-single-unit-identifiers
	const gramFormatter = useMemo(
		() => new Intl.NumberFormat(locale, { style: 'unit', unit: 'gram' }),
		[locale],
	);
	const kilogramFormatter = useMemo(
		() => new Intl.NumberFormat(locale, { style: 'unit', unit: 'kilogram' }),
		[locale],
	);

	return useCallback(
		(num: number | undefined): string =>
			num === undefined
				? ''
				: makeSpacesNoBreak(
						num < 1
							? gramFormatter.format(num * 1000)
							: kilogramFormatter.format(num),
					),
		[gramFormatter, kilogramFormatter],
	);
}
